import { render } from "./RecentPage.vue?vue&type=template&id=765e3e15"
import script from "./RecentPage.vue?vue&type=script&lang=js"
export * from "./RecentPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__